import styled from "styled-components";

export const UserInfoStyled = styled.div`
  margin-bottom: 15px;
  .user_info_container {
    margin-bottom: 5px;
    .title {
      margin-bottom: 20px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
    }
    .ui_row {
      margin-bottom: 12px;
      padding-left: 16px;
      display: flex;
      align-items: center;
      column-gap: 16px;
      &.mb_32 {
        margin-bottom: 32px;
      }
      .ui_label {
        width: ${({ lang }) => (lang === "en" ? "112px" : "88px")};
        flex-basis: calc(50% - 8px);
        color: ${({ theme }) => theme.COLORS.BLACK_4};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      }
      .ui_value {
        display: flex;
        flex-basis: calc(50% - 8px);
        min-width: 0;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
        .ui_text {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .btn_wrap {
    display: flex;
    justify-content: flex-end;
  }

  .theme_standard {
  }
`;
